export default "__VITE_ASSET__B6IBc0qk__"